export default "__VITE_ASSET__ylnzwbav__"